'use client';
import { cn } from '@/lib/utils';
const Waders = (): JSX.Element => {
  const list = [
    {
      title: 'How to Clean Waders',
      texts: [
        'Keep your waders on when cleaning.',
        'Wet your waders with a low-pressure hose.',
        'Rinse off mud, dirt, and debris with fresh water. For stubborn stains, use a soft brush and mild soap',
        'Rinse thoroughly with low-pressure water.',
      ],
    },
    {
      title: 'How to Dry Waders',
      texts: [
        'Hang to air dry in a shaded area away from direct heat and sunlight.',
        'Avoid using a blow dryer or heat, as it can damage your waders.',
        'Allow them to air dry completely, which may take several hours or overnight.',
        'Once boots are cleaned and dried, apply boot/rubber conditioner to prevent cracking.',
      ],
    },
    {
      title: 'Wader Storage',
      subTitle: '',
      texts: [
        'Turn them inside out.',
        'Store in a cool, dry place.',
        'Hang or lay flat to avoid creases.',
        'Avoid sharp objects that could puncture or tear the fabric.',
        'Consider using a wader bag for added protection.',
        'Regularly check on stored waders to ensure they remain in good condition.',
      ],
    },
    {
      title: 'Addtional Tips',
      subTitle: 'To ensure your waders are ready for action season after season, steer clear of these common pitfalls:',
      texts: [
        'Allowing waders to remain wet, which can lead to mold and mildew.',
        'Skipping a thorough cleaning before storage, leaving behind odors from previous hunts.',
        'Folding or compressing waders incorrectly, risking creases and tears.',
        'Neglecting to address any signs of mold or mildew promptly.',
        'Forgetting to inspect waders regularly for wear and tear.',
      ],
    },
  ];
  const textClassName = 'text-[16px] leading-[26px] font-roboto-light font-light mb-[10px] lg_mb-[20px]';
  return (
    <>
      {list.map((item, index) => (
        <div
          key={index}
          className='mb-[40px]'
        >
          <p
            className={cn(
              'mb-[10px] font-roboto-medium text-[18px] font-medium leading-[21px] lg_mb-[20px] lg_text-[20px] lg_leading-[28px]',
              index === 3 && 'lg_mb-[10px]',
            )}
          >
            {item.title}
          </p>
          <p className='mb-[10px] font-roboto-medium text-[16px] font-medium leading-[21px] lg_mb-[20px] lg_leading-[24px]'>
            {item.subTitle}
          </p>
          {item.texts.map((text, index) => (
            <p
              key={index}
              className={textClassName}
            >
              <span className='relative top-[-2px] mr-[10px] inline-block !h-[6px] !min-h-[6px] !w-[6px] !min-w-[6px] rounded-[6px] bg-[#000]'></span>
              {text}
            </p>
          ))}
        </div>
      ))}
    </>
  );
};
export default Waders;
